import moment from "moment";

export interface Filter {
    name: string,
    value: any
}

export interface PageFilter {
    pageName: string,
    filters: Filter[]
}

export class Filters {
    static saveFilters (item: PageFilter) {
        const filters = localStorage.getItem('filters');
        if (filters) {
            const parsedFilters: PageFilter[] = JSON.parse(filters);
            const target: PageFilter | undefined = parsedFilters.find((x: PageFilter) => x.pageName === item.pageName );
            if (target) {
                const index = parsedFilters.indexOf(target);
                target.filters = item.filters;
                parsedFilters[index] = target;
            } else {
                parsedFilters.push(item);
            }
            localStorage.setItem('filters', JSON.stringify(parsedFilters));
        } else {
            localStorage.setItem('filters', JSON.stringify([ item ]));
        }
        localStorage.setItem('filtersValidity', JSON.stringify(moment().add(1, 'd').unix()));
    }
    
    static loadFilters (): PageFilter | null {
        const filters = localStorage.getItem('filters');
        return filters ? JSON.parse(filters) : null;
    }

    static loadFilter (pageName: string, filterName: string, defaultValue: string | null = null): string | null {
        const filters = localStorage.getItem('filters');
        if (filters) {
            const parsedFilters = JSON.parse(filters);
            const target: PageFilter = parsedFilters.find((x: PageFilter) => x.pageName === pageName);
            if (target) {
                const result: Filter | null = target.filters.find((x: Filter) => x.name === filterName) ?? null;
                if (result) {
                    return result.value;
                } else {
                    return defaultValue;
                }
            } else {
                return defaultValue;
            }
        } else {
            return defaultValue;
        }
    }

    static checkFiltersValidity (): boolean {
        const validity = Number(localStorage.getItem('filtersValidity'));
        const now = moment().unix();
        if (moment(validity).isAfter(now)) {
            return true;
        } else {
            localStorage.setItem('filters', '');
            console.log('All filters were cleared due incorrect validity.')
            return false;
        }
    }

}
